import { getSessionToken, startImpersonationSession } from '../../../auth';
import { findStartPage } from '../../../../config/startPages';
import { impersonateUser } from '../allUsersApi';
import { User } from '../types';

/**
 * Вход под сотрудником из таблицы и из карточки. Право users.impersonate и ранг (только строго младший)
 * проверяет сервер; интерфейс для перехода берется из ответа (роль сотрудника), а не из названия роли.
 */
export async function impersonateAndRedirect(target: User): Promise<void> {
  // Сервер определяет оператора только по токену сессии; без него запрос заведомо будет отклонен
  const adminToken = getSessionToken();
  if (!adminToken) throw new Error('Сессия не найдена, войдите в систему заново');

  const data = await impersonateUser(target.id, adminToken);
  if (!data.sessionToken || !data.impersonator) throw new Error('Сервер не вернул сессию сотрудника');

  // Вход под сотрудником есть только в «Пользователях»: туда администратор и вернется.
  // Панель открывает вкладку из ?tab= вместо стартовой страницы роли
  const usersTab = findStartPage('admin', 'users');
  startImpersonationSession(data, data.impersonator, usersTab ? `/admin?tab=${usersTab.index}` : '/admin');
  window.location.href = data.targetInterface === 'admin' ? '/admin' : '/dashboard';
}
